import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import PikuTradeView from "@/views/PikuTradeView.vue";
import About from "@/views/About.vue";
import CGJView from "@/views/CGJView.vue";
import ReferendumView from "@/views/ReferendumView.vue";
import SkillsView from "@/views/SkillsView.vue";
import HomeLabView from "@/views/HomeLabView.vue";
import ResumeView from "@/views/ResumeView.vue";
import PortfolioView from "@/views/PortfolioView.vue";
import NDIView from "@/views/NDIView.vue";
import ProjectsView from "@/views/ProjectsView.vue";
import NotFoundView from "@/views/NotFoundView.vue";
import { usePostHog } from '@/composables/usePostHog'


const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "home",
        component: HomeView,
    },
    {
        path: "/projects",
        name: "projects",
        component: ProjectsView,
    },
    {
        path: "/ndi",
        name: "ndi",
        component: NDIView,
    },
    {
        path: "/portfolio",
        name: "portfolio",
        component: PortfolioView,
    },
    {
        path: "/about",
        name: "about",
        component: About,
    },
    {
        path: "/home",
        name: "homeAlias",
        component: HomeView,
    },
    {
        path: "/infrastructure",
        name: "infrastructure",
        component: HomeLabView,
    },
    {
        path: "/infrastructure/l0-physical-sdn",
        name: "infra-l0",
        component: () => import("@/views/infra/Layer0View.vue")
    },
    {
        path: "/infrastructure/l1-orchestration",
        name: "infra-l1",
        component: () => import("@/views/infra/Layer1View.vue")
    },
    {
        path: "/infrastructure/l2-data-persistence",
        name: "infra-l2",
        component: () => import("@/views/infra/Layer2View.vue")
    },
    {
        path: "/infrastructure/l3-secops-observability",
        name: "infra-l3",
        component: () => import("@/views/infra/Layer3View.vue")
    },
    {
        path: "/pikuTrade",
        name: "pikuTrade",
        component: PikuTradeView,
    },
    {
        path: "/codeGameJam",
        name: "cgj",
        component: CGJView,
    },
    {

        path: "/referendum",
        name: "referendum",
        component: ReferendumView,
    },
    {
        path: "/skills",
        name: "skills",
        component: SkillsView
    },
    {
        path: "/resume",
        name: "resume",
        component: ResumeView
    },
    {
        path: "/sproogy",
        name: "sproogy",
        component: () => import("@/views/SproogyView.vue")
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFoundView
    }

];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
            };
        } else {
            return { top: 0 };
        }
    },
});

const { posthog } = usePostHog()

let timer15: number | undefined;
let timer30: number | undefined;

router.afterEach((to) => {
    // Clear previous timers
    if (timer15) clearTimeout(timer15);
    if (timer30) clearTimeout(timer30);

    posthog.capture('$pageview', {
        $current_url: window.location.origin + to.fullPath,
        page_name: to.name,
        path: to.path
    });

    // Track time spent on specific heavy-content pages
    const engagingRoutes = ['cgj', 'referendum', 'ndi', 'pikuTrade', 'sproogy', 'portfolio'];
    if (to.name && engagingRoutes.includes(to.name.toString())) {
        timer15 = window.setTimeout(() => {
            posthog.capture('project_engaged', { project_name: to.name, time_spent: 'stayed_15s' });
        }, 15000);
        timer30 = window.setTimeout(() => {
            posthog.capture('project_engaged', { project_name: to.name, time_spent: 'stayed_30s' });
        }, 30000);
    }
});

export default router;
